import { LangText, SagawaDeliveryPoints } from '@/components'

const SectionTitle = () => (
  <div className="flex flex-col items-center">
    <LangText
      lngKey="home.sagawa.title"
      className="text-[36px] font-bold leading-[50px] text-[#000]"
    />
    <span className="mt-[16px] h-[4px] w-[108px] rounded-full bg-primary" />
  </div>
)

export const SagawaLogistics = () => (
  <section className="mx-auto w-[1200px] pt-[96px]">
    <SectionTitle />
    <SagawaDeliveryPoints className="mt-[82px]" />
  </section>
)
